import styled, { css } from 'styled-components';

export const Figure = styled.figure`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;

  img {
    max-width: 100%;
    max-height: 70vh;
    border-radius: 10px;
  }
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 50px;
  min-height: 50px;
  border-radius: 50%;
  background-color: transparent;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.neutral_700};
    color: ${({ theme }) => theme.neutral_100};
  }
`;

const Main_singleAttachment = css`
  width: unset;
  max-width: 80vw;

  ${Button} {
    display: none;
  }
`;

export const Main = styled.div<{ $singleAttachment: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  width: 80vw;
  min-width: 260px;
  max-width: 1200px;
  min-height: 260px;

  ${({ $singleAttachment }) => $singleAttachment && Main_singleAttachment}
`;
